import { isNumber } from '@sajari/react-sdk-utils';

function getBucketCount(response, value) {
  var _aggregateFilters$buc, _aggregateFilters$buc2, _aggregates$buckets$c, _aggregates$buckets, _count$value;

  if (!response || response != null && response.isEmpty()) {
    return null;
  }

  var count = 0;
  var aggregates = response.getAggregates();
  var aggregateFilters = response.getAggregateFilters();

  if (aggregateFilters && Object.keys((_aggregateFilters$buc = (_aggregateFilters$buc2 = aggregateFilters.buckets) == null ? void 0 : _aggregateFilters$buc2.count) != null ? _aggregateFilters$buc : {}).includes(value)) {
    count = aggregateFilters.buckets.count;
  } else if (aggregates && Object.keys((_aggregates$buckets$c = (_aggregates$buckets = aggregates.buckets) == null ? void 0 : _aggregates$buckets.count) != null ? _aggregates$buckets$c : {}).includes(value)) {
    count = aggregates.buckets.count;
  }

  if (isNumber(count)) {
    return 0;
  }

  return (_count$value = count[value]) != null ? _count$value : 0;
}

export { getBucketCount };
//# sourceMappingURL=response.esm.js.map
